export default "__VITE_ASSET__BlfMRoui__"